import { foldersCollection } from '@/firebase';


const state = {
    folderList: [],
    foldersLoading: false,
    folderCreateLoading: false,
};

// mutations
const mutations = {
    SET_FOLDERS_LIST: (state, list) => {
        state.folderList = list
    },
    SET_IS_FOLDERS_LOADING: (state, loading) => {
        state.foldersLoading = loading;
    },
    SET_CREATION_LOADING: (state, loading) => {
        state.folderCreateLoading = loading;
    },
};


// actions
const actions = {
    onFetchFolders: async ({ commit, dispatch }, parentId) => {
        try {
            commit('SET_IS_FOLDERS_LOADING', true);
            var querySnapshot = await foldersCollection.get()
            if (querySnapshot.empty) {
                commit('SET_FOLDERS_LIST', []);
            } else {
                var updatedList = [];
                querySnapshot.docs.map(doc => {
                    if (doc.data().parentId === parentId)
                        updatedList.push({
                            'documentId': doc.id,
                            'name': doc.data().name,
                            'parentId': doc.data().parentId,
                        })
                });
                commit('SET_FOLDERS_LIST', updatedList);
            }
            commit('SET_IS_FOLDERS_LOADING', false);
        } catch (error) {
            commit('SET_FOLDERS_LIST', []);
            commit('SET_IS_FOLDERS_LOADING', false);
            const notify = {
                message:
                    error || 'error',
            };
            dispatch('notify/show', notify, { root: true });
        }
    },
    onCreateFolder: async ({ commit, dispatch, state }, { folder, parentId }) => {
        try {
            commit('SET_CREATION_LOADING', true);
            const foldersDocs = await foldersCollection
                .where('name', '==', folder.name)
                .where('parentId', '==', parentId)
                .get();
            var isfolderNameDuplcated = !foldersDocs.empty;

            if (isfolderNameDuplcated) {
                const notify = {
                    message:
                        'هذا القارئ/الالمجلد موجود مسبقا نرجو التحقق من الاسم الذي ادخلته',
                };
                dispatch('notify/show', notify, { root: true });
                commit('SET_CREATION_LOADING', false);
                return false;
            } else {
                const res = await foldersCollection.add({
                    'name': folder.name,
                    'parentId': parentId,
                });
                state.folderList.push({
                    'documentId': res.id,
                    'name': folder.name,
                    'parentId': parentId,
                })
                commit('SET_CREATION_LOADING', false);
                return true;
            }
        } catch (error) {
            commit('SET_CREATION_LOADING', false);
            const notify = {
                message:
                    error || 'error',
            };
            dispatch('notify/show', notify, { root: true });
            return false;
        }
    }
};

// getters
const getters = {
    isFoldersLoading: state => state.foldersLoading || state.folderCreateLoading
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
